//filter through dish types and dietary-info
const FilterData = [
    {
        dishType: "lunch",
        isSelected: false,
    },
    {
        dishType: "dinner",
        isSelected: false,
    },
    {
        dishType: "snack",
        isSelected: false,
    },
    {
        dishType: "soup",
        isSelected: false,
    },
    {
        dishType: "side dish",
        isSelected: false,
    },
    {
        dishType: "drink",
        isSelected: false,
    },
    {
        diet: "gluten free",
        isSelected: false,
    },
]

export default FilterData;